function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_106_3545)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M55.49 37.9C55.23 37.9 54.96 37.87 54.7 37.82C52.53 37.38 51.13 35.27 51.57 33.11C51.86 31.68 52 30.21 52 28.74C52 19.16 45.88 10.75 36.77 7.81001C34.67 7.13001 33.52 4.88001 34.19 2.77001C34.87 0.670012 37.12 -0.479989 39.23 0.190011C51.65 4.21001 60 15.68 60 28.74C60 30.74 59.8 32.74 59.41 34.69C59.03 36.59 57.36 37.9 55.49 37.9Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 58.74C22.46 58.74 15.26 55.93 9.71001 50.83C8.08001 49.33 7.98001 46.8 9.47001 45.18C10.97 43.56 13.5 43.45 15.12 44.94C19.19 48.68 24.47 50.74 30 50.74C35.53 50.74 40.85 48.67 44.92 44.9C46.54 43.4 49.07 43.5 50.57 45.12C52.07 46.74 51.97 49.27 50.35 50.77C44.79 55.91 37.56 58.73 30 58.73V58.74Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.51999 37.97C2.65999 37.97 0.98999 36.66 0.59999 34.77C0.19999 32.8 -0.0100098 30.77 -0.0100098 28.75C-9.76585e-06 15.68 8.34999 4.21 20.77 0.190001C22.87 -0.489999 25.13 0.660001 25.81 2.77C26.49 4.87 25.34 7.13 23.23 7.81C14.12 10.75 7.99999 19.17 7.99999 28.74C7.99999 30.23 8.14999 31.72 8.44999 33.17C8.88999 35.34 7.48999 37.45 5.32999 37.89C5.05999 37.94 4.78999 37.97 4.52999 37.97H4.51999Z",
  fill: "#D2D6DB"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_106_3545"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 58.74,
  fill: "white"
})));

function SvgInitiated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiated);
export default __webpack_public_path__ + "static/media/initiated.098b6c2c.svg";
export { ForwardRef as ReactComponent };